/**
 * Query keys for matter estate admin data.
 *
 * The per-tab React Query hooks that used to live here (overview, contacts,
 * tasks, inventory, documents, history, invalidate-all) have been superseded
 * by direct fetches elsewhere (e.g. `lib/data/matter-overview-data.ts`,
 * `lib/services/*\/client.ts`) — this key factory is the only surviving
 * consumer-facing export, used for cache invalidation across the app.
 */

/**
 * Base query key for matter estate admin data
 */
export const MATTER_ESTATE_ADMIN_KEYS = {
  all: ['matter-estate-admin'] as const,
  matter: (matterId: number) => ['matter-estate-admin', matterId] as const,
  overview: (matterId: number) =>
    ['matter-estate-admin', matterId, 'overview'] as const,
  communications: (matterId: number) =>
    ['matter-estate-admin', matterId, 'communications'] as const,
  contacts: (matterId: number) =>
    ['matter-estate-admin', matterId, 'contacts'] as const,
  tasks: (matterId: number) =>
    ['matter-estate-admin', matterId, 'tasks'] as const,
  inventory: (matterId: number) =>
    ['matter-estate-admin', matterId, 'inventory'] as const,
  documents: (matterId: number) =>
    ['matter-estate-admin', matterId, 'documents'] as const,
  history: (matterId: number) =>
    ['matter-estate-admin', matterId, 'history'] as const,
  discovery: (matterId: number) =>
    ['matter-estate-admin', matterId, 'discovery'] as const,
  redemption: (matterId: number) =>
    ['matter-estate-admin', matterId, 'redemption'] as const,
  'vale-custody-account': (matterId: number) =>
    ['matter-estate-admin', matterId, 'vale-custody-account'] as const
} as const;
